function StarIcon({
  size = 36,
  fillLevel = '0',
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  fillLevel?: '0' | '1' | '2' | '3' | '4';
  className?: string;
  onClick?: (event) => void;
}) {
  let innerEl = <></>;
  switch (fillLevel) {
    case '0':
      innerEl = (
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.4227 5.11599L8 0L5.57731 5.11599L0 5.85681L4.08 9.75949L3.05573 15.3333L8 12.6293L12.9443 15.3333L11.92 9.75949L16 5.85681L10.4227 5.11599ZM13.0716 6.81288L9.52809 6.34221L8 3.11534L6.47191 6.34221L2.92844 6.81288L5.52136 9.29311L4.87332 12.8196L8 11.1096L11.1267 12.8196L10.4786 9.29311L13.0716 6.81288Z'
        />
      );
      break;

    case '1':
      innerEl = (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.4227 5.11599L8 0L5.57731 5.11599L0 5.85681L4.08 9.75949L3.05573 15.3333L8 12.6293L12.9443 15.3333L11.92 9.75949L16 5.85681L10.4227 5.11599ZM13.0716 6.81288L9.52809 6.34221L8 3.11534L6.47191 6.34221L2.92844 6.81288L5.52136 9.29311L4.87332 12.8196L8 11.1096L11.1267 12.8196L10.4786 9.29311L13.0716 6.81288Z'
          />
          <path d='M6.5 4V13L6 13.5L3.05573 15.3333L4.08 9.75949L0 5.85681L5.57731 5.11599L6.5 4Z' />
        </>
      );
      break;

    case '2':
      innerEl = (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.4227 5.11599L8 0L5.57731 5.11599L0 5.85681L4.08 9.75949L3.05573 15.3333L8 12.6293L12.9443 15.3333L11.92 9.75949L16 5.85681L10.4227 5.11599ZM13.0716 6.81288L9.52809 6.34221L8 3.11534L6.47191 6.34221L2.92844 6.81288L5.52136 9.29311L4.87332 12.8196L8 11.1096L11.1267 12.8196L10.4786 9.29311L13.0716 6.81288Z'
          />
          <path d='M8 0V12.6293L3.05573 15.3333L4.08 9.75949L0 5.85681L5.57731 5.11599L8 0Z' />
        </>
      );
      break;

    case '3':
      innerEl = (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.4227 5.11599L8 0L5.57731 5.11599L0 5.85681L4.08 9.75949L3.05573 15.3333L8 12.6293L12.9443 15.3333L11.92 9.75949L16 5.85681L10.4227 5.11599ZM13.0716 6.81288L9.52809 6.34221L8 3.11534L6.47191 6.34221L2.92844 6.81288L5.52136 9.29311L4.87332 12.8196L8 11.1096L11.1267 12.8196L10.4786 9.29311L13.0716 6.81288Z'
          />
          <path d='M8 2L9 3.5L9.5 5V12.5L8 12.6293L3.05573 15.3333L4.08 9.75949L0 5.85681L5.57731 5.11599L8 2Z' />
        </>
      );
      break;

    case '4':
      innerEl = (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.4227 5.11599L8 0L5.57731 5.11599L0 5.85681L4.08 9.75949L3.05573 15.3333L8 12.6293L12.9443 15.3333L11.92 9.75949L16 5.85681L10.4227 5.11599ZM13.0716 6.81288L9.52809 6.34221L8 3.11534L6.47191 6.34221L2.92844 6.81288L5.52136 9.29311L4.87332 12.8196L8 11.1096L11.1267 12.8196L10.4786 9.29311L13.0716 6.81288Z'
          />
          <path d='M8 2L9 3.5L10 5.5L14.5 6.5L11.7767 9.75949L12 14L9.5 12.5L8 12.6293L3.05573 15.3333L4.08 9.75949L0 5.85681L5.57731 5.11599L8 2Z' />
        </>
      );
      break;

    default:
      break;
  }
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 16'
        fill='currentColor'
      >
        {innerEl}
      </svg>
    </span>
  );
}

export default StarIcon;
